<template>
  <form
    autocomplete="off"
    class="m-edition-billing-academy-migration-search-sale"
    @submit.prevent="false"
  >
    <AtomInputPrimary
      v-model="venta"
      name="venta"
      :placeholder="`Ingresa aquí el UUID de la venta ${tipo}`"
      type="text"
      wrapper-class="a-input-wrapper-row"
    />
    <AtomButtonSecondary
      :button-secondary="buttonSecondary.readVenta"
      :disabled="venta.loading"
      :show-loading="loading"
      @readVentaDatosMigracion="readVentaDatosMigracion"
    />
  </form>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademyMigrationSearchSale',

  props: {
    item: {
      type: String,
      default: '0'
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      buttonSecondary: {
        readVenta: {
          class: 'a-button-secondary a-button-billing-secondary',
          component: '',
          icon: 'fas fa-search',
          method: 'readVentaDatosMigracion',
          text: 'Buscar',
          type: 'button'
        }
      },

      tipo: '',
      venta: ''
    }
  },

  watch: {
    loading () {
      console.log('watch loading')
      console.log(this.loading)
    }
  },

  created () {
    this.tipo = this.item === '0' ? 'actual' : 'nueva'
  },

  methods: {
    readVentaDatosMigracion () {
      this.$emit('readVentaDatosMigracion', { id: this.venta, index: this.item })
    }
  }
}
</script>
